
export default {
    name: "endscore",
    data: () => {
        return {
            visible: false,
            win: false,
            leave: false,
            opponent: "",
        }
    },

    mounted() {

    },

    beforeDestroy() {

    },

    methods: {
        restart(){
            this.$parent.restartGame()
        },
        spanify(text, delay) {
            let t = text.split(" ")
            let out = ""
            let tmp = 0
            t.forEach(l => {
              out += ' <span class="word"> '
              let w = l.split("")
              w.forEach(c => {
                if (delay) {
                  out += '<span style=" transition-delay:' + tmp * .015 + 's" class="letter">'
                  out += c
                  out += '</span>'
                  tmp++
                } else {
                  out += '<span class="letter">'
                  out += c
                  out += '</span>'
                  tmp++
                }
              })
              out += '</span>'
            })
            return out
          }
    }
}
